import React from "react";

const Button = ({ text, onClick, width, color }) => {
  return (
    <button
      style={{ backgroundColor: color }}
      className={`w-full sm:inline-block sm:w-auto sm:px-[50px] py-[15px] cursor-pointer text-[0.9em] text-white rounded-[50px] uppercase font-semibold border-none`}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export default Button;
